async function callReferralApi(token) {
  const graphqlQuery = 
    `query UnauthenticatedReferralCampaign {
      unauthenticated {
        referral {
          referral_campaign(token: "${token}") {
            __typename
            ... on UnauthenticatedReferAFriendCampaign {
              bonus_amount
              fine_print
              heading
              id
              pill_text
              referral_token
              referring_user_id
              referring_user_name
              sub_heading
              urgency_offer_incentive_cohort_name
              urgency_offer_receiver_inventive_ttl
            }
            ... on GenericError {
              title
              message
            }
          }
        }
      }
    }`;
  const response = await sscmsFetchGraphQL(graphqlQuery);
  return response;
}
